import { googleAnalyticsLegacy } from "../../utils/googleAnalytics";
export default function navigate(url, track, newTab) {
    function run() {
        doNavigation(url, newTab);
    }
    googleAnalyticsLegacy("push", ['_set', 'hitCallback', () => {
            run();
        }]);
    googleAnalyticsLegacy("push", ['_trackPageview', track]);
    // fallback in case 'hitCallback' won't work
    setTimeout(run, 111);
}
function doNavigation(url, newTab) {
    if (newTab) {
        window.open(url);
    }
    else {
        window.location.href = url;
    }
}
//# sourceMappingURL=navigate.js.map